import React, { useEffect, useState } from "react";
import apiRoutes from "../../../api/apiRoutes";
import { appFetchJson } from "../../../utils/http";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import ProductoAutocomplete from "../../../components/autocomplete/ProductoAutocomplete";
import InputNumberNoScroll from "../../../components/inputs/inputNumberNoScroll";

// Importamos el componente genérico
import DrawerFilter from "../../../components/listing/DrawerFilter";

export default function FiltroPrecioProductoEessFuturo({
  initialFilters = {},
  onSubmit = () => {},
  onClose = () => {},
}) {
  // --- ESTADOS ---
  const [selectedEess, setSelectedEess] = useState(
    initialFilters.eessId
      ? { id: initialFilters.eessId, label: initialFilters.eessNombre || "Estación seleccionada" }
      : null
  );

  const [selectedProducto, setSelectedProducto] = useState(
    initialFilters.productoId
      ? { id: initialFilters.productoId, codigo: initialFilters.productoNombre || "Producto seleccionado" }
      : null
  );

  const [precio, setPrecio] = useState(initialFilters.precio || "");
  const [fecha, setFecha] = useState(initialFilters.fecha || ""); 
  const [fechaVigencia, setFechaVigencia] = useState(initialFilters.fechaVigenciaIni || ""); 
  const [estadoId, setEstadoId] = useState(initialFilters.estadoId || "");
  const [estados, setEstados] = useState([]);

  // Estado de carga
  const [isLoading, setIsLoading] = useState(false);

  // --- CARGA DE CATÁLOGOS ---
  useEffect(() => {
    const cargarCatalogos = async () => {
      try {
        const resEst = await appFetchJson(apiRoutes.estado.listUrl({ page: 0, size: 100 }));
        const todosLosEstados = resEst?.items || [];
        setEstados(todosLosEstados.filter((e) => e.tipoId === 29));
      } catch (e) {
        console.error("Error cargando estados:", e);
      }
    };
    cargarCatalogos();
  }, []);

  // --- APLICAR FILTROS ---
  const handleApply = async () => {
    setIsLoading(true);
    
    // --- LÓGICA DE LIMPIEZA SOLICITADA ---
    // Mantenemos el input como "number", pero aseguramos limpieza total antes de enviar.
    let precioLimpio = null;

    if (precio) {
      // 1. Convertimos a string para poder manipular
      const precioStr = precio.toString();
      
      // 2. replace(/\D/g, ""): Elimina TODO lo que NO sea un dígito (0-9).
      //    Esto borra puntos (.), comas (,), signos (+/-) y espacios.
      //    Ej: "75000.00" -> "7500000"
      //    Ej: "5.000"    -> "5000"
      const soloNumeros = precioStr.replace(/\D/g, "");
      
      precioLimpio = Number(soloNumeros);
    }

    onSubmit({
      eessId: selectedEess?.id || null,
      productoId: selectedProducto?.id || null,
      
      eessNombre: selectedEess?.label || null,
      productoNombre: selectedProducto?.codigo || null,

      // Enviamos el precio limpio (solo números)
      precio: precioLimpio,
      
      fecha: fecha || null,
      fechaVigenciaIni: fechaVigencia || null,
      estadoId: estadoId || null,
    });
    
    setIsLoading(false);
    onClose();
  };

  return (
    <DrawerFilter
      title="Filtros Precio Futuro"
      onClose={onClose}
      onApply={handleApply}
      isLoading={isLoading}
    >
      {/* 1. EE.SS. */}
      <div>
        <label className="form-label-fil">EE.SS.:</label>
        <div className="mt-1">
          <EessAutocomplete
            value={selectedEess}
            onChange={setSelectedEess}
            placeholder="Buscar estación..."
            className="w-full"
          />
        </div>
      </div>

      {/* 2. Producto */}
      <div>
        <label className="form-label-fil">Producto:</label>
        <div className="mt-1">
          <ProductoAutocomplete
            value={selectedProducto}
            onChange={setSelectedProducto}
            placeholder="Buscar producto..."
            className="w-full"
          />
        </div>
      </div>

      {/* 3. Valor Precio (TYPE NUMBER con limpieza al enviar) */}
      <div>
        <label className="form-label-fil">Valor Precio:</label>
        <InputNumberNoScroll
          className="input mt-1 w-full"
          value={precio}
          onChange={(e) => setPrecio(e.target.value)}
          placeholder="Ej: 5000"
          inputMode="numeric"
        />
        <p className="text-xs text-gray-400 mt-1">
           Se eliminarán puntos y caracteres especiales al filtrar.
        </p>
      </div>

      {/* 4. Fecha Creación */}
      <div>
        <label className="form-label-fil">Fecha Creación:</label>
        <input
          type="date"
          className="input mt-1 w-full"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />
        <p className="text-xs text-gray-400 mt-1">Fecha de registro en sistema.</p>
      </div>

      {/* 5. Fecha Vigencia */}
      <div>
        <label className="form-label-fil text-blue-700 font-semibold">Fecha Vigencia:</label>
        <input
          type="date"
          className="input mt-1 w-full border-blue-300 ring-blue-100 focus:ring-blue-200"
          value={fechaVigencia}
          onChange={(e) => setFechaVigencia(e.target.value)}
        />
        <p className="text-xs text-gray-500 mt-1">Fecha de aplicación del precio.</p>
      </div>

      {/* 6. Estado */}
      <div>
        <label className="form-label-fil">Estado:</label>
        <select
          className="input mt-1 w-full"
          value={estadoId}
          onChange={(e) => setEstadoId(e.target.value)}
        >
          <option value="">-- Todos --</option>
          {estados.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.nombre}
            </option>
          ))}
        </select>
      </div>

    </DrawerFilter>
  );
}